import { z } from "zod";

const contactFormSchema = z.object({
  customerFirstName: z.string().trim().min(1, { message: "Must have a value" }),
  customerLastName: z.string().trim().min(1, { message: "Must have a value" }),
  customerEmail: z
    .string()
    .trim()
    .min(1, { message: "Email is required" })
    .email({
      message: "Must be a valid email",
    }),
  customerPrimaryPhone: z
    .string()
    .trim()
    .min(10, { message: "Must be a valid phone number" })
    .max(15, {
      message: "Phone number should be in the format (###) ###-####",
    })
    .refine((phone) => phone.trim().replace(/_/g, "").length > 13, {
      message: "Must be complete phone number",
    }),
});

type ContactFormSchemaValidationType = z.infer<typeof contactFormSchema>;

export type { ContactFormSchemaValidationType };
export { contactFormSchema };
